import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import {
  updateUserApp,
  getUserAppById,
} from "../pages/userapp/ServiceUserApp";

import { getAllStatut } from "../pages/statut/ServiceStatut";



export default function ModifUser() {
  const { t } = useTranslation();
  const { id } = useParams();

  const navigate = useNavigate();

  const [statuts, setStatuts] = useState([]);

const [data, setData] = useState({
  id: "",
  fullName: "",
  email: "",
  phoneNumber: "",
  webSide: "",
  photoUrl: "",
  dateStartActv: "",
  statutId: "",
});

  const [errorMessage, setErrorMessage] = useState({});


  // ======================
  // Chargement des WILAYAS
  // ======================
  const loadStatuts = async () => {
    try {
      const result = await getAllStatut();

      const sortedData = [...result.data].sort(
        (a, b) => Number(a.codeStatut) - Number(b.codeStatut)
      );

      setStatuts(sortedData);
    } catch (error) {
      //console.log(error);
    }
  };


  
  // ======================
  // Chargement des données
  // ======================
  const loadUserApp = async () => {
    try {
      const result = await getUserAppById(id);

      const c = result.data;

   setData({
    id: c.id,
    fullName: c.fullName || "",
    email: c.email || "",
    phoneNumber: c.phoneNumber || "",
    webSide: c.webSide || "",
    photoUrl: c.photoUrl || "",
    dateStartActv: c.dateStartActv
        ? c.dateStartActv.substring(0,10)
        : "",
    statutId: c.statut ? c.statut.id : "",
   });

    } catch (error) {
      console.error(error);
      toast.error("Impossible de charger l'enregistrement");
    }
  };

  // ======================
  // INITIALISATION
  // ======================
  useEffect(() => {
    loadStatuts();
    loadUserApp();
  }, [id]);


  
  // ======================
  // Gestion des champs
  // ======================
  const onInputchange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };


  // ======================
  // SUBMIT UPDATE
  // ======================
  const onSubmit = async (e) => {
    e.preventDefault();

    try {
const payload = {
    id: data.id,
    fullName: data.fullName,
    email: data.email,
    phoneNumber: data.phoneNumber,
    webSide: data.webSide,
    photoUrl: data.photoUrl,
    dateStartActv: data.dateStartActv,
    statut: {
        id: Number(data.statutId),
    },
};

      await updateUserApp(payload);

      toast.success("UserApp modifiée avec succès !", {
        position: "bottom-right",
        autoClose: 2000,
      });

      setErrorMessage({});
      navigate("/");

    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {
        const errorArray = error.response.data.errors;

        const formattedErrors = errorArray.map((err, index) => {
          const message =
            err.indexOf(":") > -1 ? err.split(":")[1] : err;

          return (
            <li className="list-group-item" key={index}>
              {message}
            </li>
          );
        });

        toast.error(
          <div style={{ width: "18rem" }}>
            <div className="card-header text-danger">
              <h5 className="card-title">{t("common.validationErrors")}</h5>
            </div>
            <div className="card-body">
              <ul className="list-group list-group-flush">
                {formattedErrors}
              </ul>
            </div>
          </div>,
          {
            position: "bottom-right",
            autoClose: 4000,
          }
        );

        const errorObject = {};

        errorArray.forEach((err) => {
          if (err.indexOf(":") > -1) {
            const [field, message] = err.split(":");
            errorObject[field.trim()] = message.trim();
          }
        });

        setErrorMessage(errorObject);
      } else {
        toast.error(t("validation.updateError"));
        console.error(error);
      }
    }
  };

  
  return (
    <div className="container mt-5">

      <div className="row justify-content-center">

        <div className="col-md-8">

          <div className="card shadow">

            <div className="card-body p-4">

              <h3 className="text-center mb-4">
                Mon Profil Professionnel
              </h3>

              <form onSubmit={onSubmit}>

                                <div className="mb-3">
                  <label className="form-label required-label">
                    id
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="id"
                    value={data.id || ""}
                    readOnly
                    onChange={onInputchange}
                  />

                  {errorMessage.id && (
                    <div className="text-danger mt-1">
                      {errorMessage.id}
                    </div>
                  )}
                </div>

                {/* Nom complet */}
                <div className="mb-3">

                  <label>Nom complet</label>

                  <input
                    type="text"
                    name="fullName"
                    className={`form-control ${
                      errorMessage.fullName
                        ? "is-invalid"
                        : ""
                    }`}
                    value={data.fullName}
                    onChange={onInputchange}
                  />

                  {errorMessage.fullName && (
                    <div className="invalid-feedback">
                      {errorMessage.fullName}
                    </div>
                  )}

                </div>

                {/* Email */}
                <div className="mb-3">

                  <label>Email</label>

                  <input
                    type="email"
                    name="email"
                    className={`form-control ${
                      errorMessage.email
                        ? "is-invalid"
                        : ""
                    }`}
                    value={data.email}
                    onChange={onInputchange}
                  />

                  {errorMessage.email && (
                    <div className="invalid-feedback">
                      {errorMessage.email}
                    </div>
                  )}

                </div>

                {/* Téléphone */}
                <div className="mb-3">

                  <label>Téléphone</label>

                  <input
                    type="text"
                    name="phoneNumber"
                    className="form-control"
                    value={data.phoneNumber}
                    onChange={onInputchange}
                  />

                </div>

                {/* Site Web */}
                <div className="mb-3">

                  <label>Site Web</label>

                  <input
                    type="text"
                    name="webSide"
                    className="form-control"
                    value={data.webSide}
                    onChange={onInputchange}
                  />

                </div>

                {/* URL Photo */}


                {/* Aperçu photo */}
                {data.photoUrl && (
                  <div className="text-center mb-3">
                    <img
                      src={data.photoUrl}
                      alt="profil"
                      className="img-thumbnail"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )}

                {/* Date activité */}
                <div className="mb-3">

                  <label>
                    Début d'activité
                  </label>

                  <input
                    type="date"
                    name="dateStartActv"
                    className="form-control"
                    value={data.dateStartActv}
                    onChange={onInputchange}
                  />

                </div>

                <div className="mb-3">
    <label>Statut</label>

    <select
        className="form-select"
        name="statutId"
        value={data.statutId}
        onChange={onInputchange}
    >
        <option value="">Choisir...</option>

        {statuts.map((s) => (
            <option key={s.id} value={s.id}>
                {s.codeStatut} - {s.statut}
            </option>
        ))}
    </select>
</div>

                {/* erreur globale */}
                {errorMessage.global && (
                  <div className="alert alert-danger">
                    {errorMessage.global}
                  </div>
                )}

                <button
                  type="submit"
                  className="btn btn-success w-100"
                >
                  {t("button.save")} les modifications
                </button>

              </form>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}